import React from 'react';

import { formatDate, NcEstimatedMinimumPaymentT } from '@consumer-frontend/nc-utils';

import { NcExpandableListItem } from '../NcExpandableListItem';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/draw-request/minimum-payment-estimations.scss';

export type NcMinimumPaymentEstimationT = React.FC<NcEstimatedMinimumPaymentT>;

export const NcMinimumPaymentEstimation: NcMinimumPaymentEstimationT = ({
  feeDue,
  minimumPayment,
  outstandingPrincipal,
  paymentDate,
  principalDue,
}) => {
  const dropdown = (
    <dl className="dropdown-body">
      <div>
        <dt>Outstanding Principal Balance:</dt>
        <dd>{outstandingPrincipal}</dd>
      </div>
      <div>
        <dt>Principal Due Outstanding:</dt>
        <dd>{principalDue}</dd>
      </div>
      <div>
        <dt>Fee Due:</dt>
        <dd>{feeDue}</dd>
      </div>
    </dl>
  );

  return (
    <NcExpandableListItem
      title={formatDate(paymentDate, { withoutWeekday: true })}
      body={`${minimumPayment} Minimum Payment`}
      className="nc-minimum-payment-estimation"
      dropdownBody={dropdown}
    />);
};
